export default __webpack_public_path__ + "static/media/455.cdbc0a62.png";